import { render, staticRenderFns } from "./sos_sender_detail.vue?vue&type=template&id=5046ff72&scoped=true&"
import script from "./sos_sender_detail.vue?vue&type=script&lang=js&"
export * from "./sos_sender_detail.vue?vue&type=script&lang=js&"
import style0 from "./sos_sender_detail.vue?vue&type=style&index=0&id=5046ff72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5046ff72",
  null
  
)

export default component.exports